import { Navbar as PrestyledNavbar } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import styled from 'styled-components'

const Navbar = styled(PrestyledNavbar)`
    padding: 20px 24px;

    @media (min-width: ${TABLET}px) {
        padding: 16px 24px;
    }

    @media (min-width: ${DESKTOP}px) {
        padding: 16px 24px;
    }
`

export default Navbar
